<template>
  <div :class="classes">
    <div class="wf-flex wf-justify-center wf-items-center">
      <div class="wf-w-0 wf-flex-1"></div>
      <nav class="wf-flex-2">
        <ul class="wf-flex wf-justify-center wf-items-center" :class="containerNavLinkClasses">
          <template v-for="(navLink, index) in leftSideNavLinks">
              <HeaderNavLink
                :key="`left_${index}`"
                :navLink="navLink"
                :classes="navLinkClasses"
                :styles="navLinkStyles"
                :subMenuContainerClasses="subMenuContainerClasses"
                :subMenuContainerStyles="subMenuContainerStyles"
                :subMenuClasses="subMenuClasses"
                :subMenuStyles="subMenuStyles"
                :megaMenuClasses="megaMenuClasses"
                :megaMenuStyles="megaMenuStyles"
                :megaMenuFullWidth="megaMenuFullWidth"
                :megaMenuContainerClasses="megaMenuContainerClasses"
                :megaMenuContainerStyles="megaMenuContainerStyles"
                :megaMenuTitleClasses="megaMenuTitleClasses"
                :megaMenuTitleStyles="megaMenuTitleStyles"
              />
            </template>
          <li><img class="wf-w-48" src="https://storage.googleapis.com/wfs/images/logo-01.png" alt=""></li>
          <template v-for="(navLink, index) in rightSideNavLinks">
              <HeaderNavLink
                :key="`right_${index}`"
                :navLink="navLink"
                :classes="navLinkClasses"
                :styles="navLinkStyles"
                :subMenuClasses="subMenuClasses"
                :subMenuStyles="subMenuStyles"
                :megaMenuClasses="megaMenuClasses"
                :megaMenuStyles="megaMenuStyles"
                :megaMenuContainerClasses="megaMenuContainerClasses"
                :megaMenuContainerStyles="megaMenuContainerStyles"
                :megaMenuTitleClasses="megaMenuTitleClasses"
                :megaMenuTitleStyles="megaMenuTitleStyles"
              />
            </template>
        </ul>
      </nav>
      <div class="wf-w-0 wf-flex-1 wf-text-right">
        <div class="wf-inline-block" :class="ctaClasses" :style="ctaStyles" v-show="hasCta">
          <div v-text="ctaText"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  import HeaderContract from '../../contracts/HeaderContract'
  export default HeaderContract.extend({
    computed: {
      leftSideNavLinks() {
        return _.chunk(this.navLinks, Math.round(this.navLinks.length /2))[0]
      },
      rightSideNavLinks() {
        return _.chunk(this.navLinks, Math.round(this.navLinks.length /2))[1]
      }
    },
  })
</script>